import React, { PropTypes } from "react";

import { GuaranteeLineItem } from "./";

class RenderLineItems extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.guarantees
      .sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      })
      .map((guarantee) => {
        this.props.fields.push(guarantee);
      });
  }

  componentWillReceiveProps(nextProps) {
    nextProps.fields.removeAll();
    nextProps.guarantees.forEach((guarantee, index) => {
      if (nextProps.formValues[nextProps.fields.name]) {
        const match = nextProps.formValues[nextProps.fields.name].find(
          (split) => {
            return split.clientCoverageId === guarantee.clientCoverageId;
          }
        );
        if (match) {
          nextProps.fields.push({ ...match, order: index + 1 });
        } else {
          nextProps.fields.push({
            ...guarantee,
            order: index + 1,
          });
        }
      } else {
        nextProps.fields.push({
          ...guarantee,
          order: index + 1,
        });
      }
    });
  }

  render() {
    return (
      <div>
        {this.props.fields.map((split, index) => {
          if (this.props.formValues[this.props.fields.name][index]) {
            return (
              <GuaranteeLineItem
                key={index}
                index={index}
                disabled={this.props.disabled}
                listId={this.props.id}
                guarantee={this.props.formValues[this.props.fields.name][index]}
                split={split}
                valueType={this.props.valueType}
                removeGuarantee={this.props.removeGuarantee}
                moveGuarantee={this.props.moveGuarantee}
              />
            );
          }
          return <div key={index} />;
        })}
      </div>
    );
  }
}

RenderLineItems.propTypes = {
  disabled: PropTypes.bool,
  fields: PropTypes.object,
  formValues: PropTypes.object,
  guarantees: PropTypes.array,
  id: PropTypes.string,
  moveGuarantee: PropTypes.func,
  name: PropTypes.string,
  removeGuarantee: PropTypes.func,
  valueType: PropTypes.string,
};

export default RenderLineItems;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/RenderLineItems.js